import { render } from "./ModalVerTipoEvento.vue?vue&type=template&id=d18e2894"
import script from "./ModalVerTipoEvento.vue?vue&type=script&lang=js"
export * from "./ModalVerTipoEvento.vue?vue&type=script&lang=js"

import "./ModalVerTipoEvento.vue?vue&type=style&index=0&id=d18e2894&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__